import React from 'react';
import PropTypes from 'prop-types';
import BasicPage, { Title, Container } from '@layout/BasicPage';
import { Content, UtilityPanel, LogoContainer } from '@layout/UtilityPage';
import thirdBridgeLogo from '@assets/ThirdBridgeLogo.svg';

const UtilityPageTemplate = ({ title, children }) => (
  <BasicPage>
    <LogoContainer>
      <img src={thirdBridgeLogo} alt="Third Bridge logo" />
    </LogoContainer>
    <UtilityPanel>
      <Container>
        <Title>{title}</Title>
        <Content>{children}</Content>
      </Container>
    </UtilityPanel>
  </BasicPage>
);

UtilityPageTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subheader: PropTypes.element,
};

UtilityPageTemplate.defaultProps = {
  subheader: null,
};

export default UtilityPageTemplate;



// WEBPACK FOOTER //
// ./components/templates/UtilityPageTemplate/UtilityPageTemplate.js